import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {Stack} from '@mantine/core';

import {FormPageLayout, PlatformLoader} from '@flexinet/ui-components';

import {Profile} from '../profile/Profile.tsx';
import {FormDrawer} from '../drawers/FormDrawer.tsx';
import {EditPageNavigation} from '../navigation/EditPageNavigation.tsx';
import {useInvoice} from '../hooks/useInvoice.ts';
import {useInvoicesSelection} from '../hooks/useInvoicesSelection.ts';
import {useEditPageTools} from '../hooks/useEditPageTools.tsx';
import {Invoice} from '../types';

export const EditPage = () => {
    const {id: invoiceId} = useParams();

    if (typeof invoiceId === 'undefined') {
        throw new Error('invoiceId is required parameter');
    }

    const {
        record: invoice,
        loading,
        updateRecord,
    } = useInvoice(invoiceId);

    const {handleClearSelection} = useInvoicesSelection();

    const [drawerOpened, setDrawerOpened] = useState(false);
    const {tools} = useEditPageTools({onEdit: () => setDrawerOpened(true)});

    useEffect(() => {
        handleClearSelection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading || !invoice) {
        return <PlatformLoader message='Loading invoice...Please wait'/>;
    }

    const handleDrawerSubmit = (values: Invoice) => {
        updateRecord(values);
    };

    return (
        <FormPageLayout
            title={invoice.id}
            pageNavigation={<EditPageNavigation component={invoice}/>}
            tools={tools}
        >
            <Stack gap='lg'>
                <Profile record={invoice}/>
            </Stack>

            <FormDrawer
                record={invoice}
                handleSubmit={handleDrawerSubmit}
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        </FormPageLayout>
    );
};
